module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-canonical-urls@3.15.0_gatsby@3.15.0/node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://firebirdmovie.com"},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-image@1.15.0_@babel+core@7.29.7_gatsby-plugin-sharp@3.15.0_gatsby-source-filesy_rbd32l3cj5fygqzpolhlivsihm/node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@3.15.0_gatsby@3.15.0_graphql@15.10.2/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Firebird","short_name":"firebird","start_url":"/","background_color":"#FFF","display":"minimal-ui","icon":"src/images/F.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"a3e5fecf81340532bc34ba4e62c58ad1"},
    },{
      plugin: require('../node_modules/.pnpm/@sentry+gatsby@6.19.7_gatsby@3.15.0_react@17.0.2/node_modules/@sentry/gatsby/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://2452d551c6ff484f8db7ba9bbfb80876@o1057175.ingest.sentry.io/6043839","includeInDevelopment":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
